const Session = {
    login: function (data) {
        localStorage.setItem('session', JSON.stringify(data));
    },
    logout: function () {
        localStorage.removeItem('session');
        localStorage.clear();
    },
    update: function (newData) {
        localStorage.removeItem('session');
        localStorage.setItem('session', JSON.stringify(newData));
    },
    setRedirectTo: function (url) {
        localStorage.setItem('redirectTo', url);
    },
    getRedirectTo: function () {
        const redirectTo = localStorage.getItem('redirectTo');
        localStorage.removeItem('redirectTo');
        return redirectTo;
    },
    getLogin: function () {
        const data = localStorage.getItem('session');
        return JSON.parse(data);
    },
};

export default Session